"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadCSSAssets = exports.loadAssets = exports.loadBatchAssets = exports.loadLibraryAssets = void 0;
var flags_1 = require("../flags");
function isCSSAssetLoaded(url) {
    return (
    // pre fetched (inlined) style tag
    document.querySelector("style[data-href=\"" + url + "\"]") !== null ||
        // normal CSS import
        document.querySelector("link[href=\"" + url + "\"]"));
}
function injectStyleTag(url) {
    var style = document.createElement('link');
    style.setAttribute('rel', 'stylesheet');
    style.setAttribute('type', 'text/css');
    style.setAttribute('href', url);
    document.head.appendChild(style);
}
function loadLibraryAssets(assets) {
    // ignore batch assets
    loadAssets(assets.filter(function (asset) { return !asset.batch; }));
}
exports.loadLibraryAssets = loadLibraryAssets;
function loadBatchAssets(assets, batchName) {
    loadAssets(assets.filter(function (asset) { return asset.batch === batchName; }));
}
exports.loadBatchAssets = loadBatchAssets;
function loadAssets(assets) {
    loadCSSAssets(assets.filter(function (asset) { return asset.type === 'style' && asset.extension === 'css'; }));
}
exports.loadAssets = loadAssets;
function loadCSSAssets(assets) {
    if (flags_1.isServer) {
        return;
    }
    assets
        .filter(function (_a) {
        var url = _a.url;
        return !isCSSAssetLoaded(url);
    })
        .forEach(function (_a) {
        var url = _a.url;
        injectStyleTag(url);
    });
}
exports.loadCSSAssets = loadCSSAssets;
//# sourceMappingURL=loadAssets.js.map